export default __webpack_public_path__ + "static/media/cross.63492fd3.svg";